<template>
  <div class="login-dialog--login__content-container">
    <div class="login-dialog--login__content-container--text">
      <h2 class="login-dialog--login__content-container--text__title">
        {{ title }}
      </h2>
      <span class="login-dialog--login__content-container--text__subtitle">{{
        description
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "the-number-in-use",
  props: {
    title: {
      required: true,
      default: "",
    },
    description: {
      required: true,
      default: "",
    },
  },
};
</script>